import { html, type TemplateResult } from 'lit';

export function renderAccommodationOnTour(accommodationOnTourData: {
    title: string;
    content: string | null | undefined;
}): TemplateResult | null {
    if (!accommodationOnTourData?.content) {
        return null;
    }

    return html`
        <div class="productinfo-accommodation-on-tour">
            <der-ui-tile
                title="${accommodationOnTourData.title}"
                content="${accommodationOnTourData.content}"
            ></der-ui-tile>
        </div>
    `;
}
